import styled from 'styled-components';
import { getColor, makePercent, StyleVars, typeScale } from 'core/utils';

export const Wrapper = styled.section`
	padding: 32px 0;
`;

export const Row = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: 0 -21px;
`;

export const Col = styled.div`
	padding: 0 21px;
	max-width: ${makePercent(4,8)};
	flex-basis: ${makePercent(4,8)};
	@media(max-width: 767px) {
		max-width: ${makePercent(8,8)};
		flex-basis: ${makePercent(8,8)};
		& + & {
			margin-top: 16px;
		}
	}
`;

export const Title = styled.h4`
	font-weight: 600;
	font-size: 16px;
	line-height: 19px;
	margin-bottom: 26px;
	color: ${getColor('gray')};
	@media(max-width: ${StyleVars.screenSm}) {
		margin: ${typeScale(1)} 0;
	}
`;

export const Links = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const SingleTag = styled.a`
	display: block;
	text-decoration: none;
	text-align: center;
	margin-right: 16px;
	margin-bottom: 16px;
	padding: 15px 22px;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.2px;
	color: ${getColor('gray')};
	border-radius: 24px;
	background-color: #f2f5f5;

	@media(max-width: ${StyleVars.screenSm}) {
		margin: ${typeScale(0.5)} 0;
	}
`;
